
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.rowGap = this.getBreakpointValue(this.blok.rowGap)
      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.placeSelf = this.getBreakpointValue(this.blok.placeSelf)

      return styles
    },
  },
}
